import { differenceInDays, isValid, parseISO } from 'date-fns';

export const daysToExpiration = (dateStr?: string | null, now: Date = new Date()): number | null => {
  if (!dateStr) return null;

  const expiryDate = parseISO(dateStr);

  if (!isValid(expiryDate)) return null;

  return differenceInDays(expiryDate, now);
};
